import {
  Link,
  Redirect,
  Route,
  useHistory,
  useLocation,
} from "react-router-dom";
import PropTypes from "prop-types";
import { useKeycloak } from "@react-keycloak/web";
import logo from "../../assets/images/logo.png";
import logOut from "../../assets/images/log_out.svg";
import { useMutation } from "react-query";

import { createClassPlan } from "../../api/classPlan";
import { useSelector } from "react-redux";
import { getClassDetailsById } from "../../utils/reactQueries";

const InternalTeacher = ({ component: Component, ...rest }) => {
  const { keycloak } = useKeycloak();
  const history = useHistory();
  const isClassPlanUpdate = useSelector(
    (state) => state.classPlan.isClassPlanUpdate
  );
  let redirectRoute = null;
  const { pathname } = useLocation();
  const slicePath = pathname.split("/");
  const classCreatedURl = slicePath[1];

  /** below lines used to check pathname  have class-plan path or not*/
  const pathArray = pathname.split("/");
  const isClassPlanPath = pathArray.some((item) =>
    pathname.includes("class-plan")
  );
  const classID = localStorage.getItem("classId");

  if (keycloak && keycloak.authenticated) {
    const isTeacher = keycloak.realmAccess.roles.includes("teacher");
    if (!isTeacher) {
      redirectRoute = "/student/upcoming-class";
    }
  } else {
    redirectRoute = "/login";
  }

  const {
    status,
    data: classData,
    error: classError,
    isFetching,
  } = getClassDetailsById(classID);
  const classDetails = classData?.data;

  //add content to the current playlist
  const { mutate: createNewClassPlan } = useMutation(createClassPlan, {
    onSuccess: (data, variables) => {
      if (data.status === 201) {
        const classPlanID = data?.data?.body?.id;
        localStorage.setItem("classPlanID", classPlanID);
        if (classPlanID) {
          history.push(`/class/${classID}/class-plan/${classPlanID}`);
        }
      }
    },
    onError: (err) => {
      console.log(err);
      alert("Something Went wrong...");
    },
  });

  //function used to redirect if the classPlan else creating the new class plan for current class then redirect to the class-plan

  const redirectToCreateClassPlan = () => {
    const classPlanID = classDetails?.classPlan?.id;
    if (classPlanID) {
      localStorage.setItem("classPlanID", classPlanID);
      history.push(`/class/${classID}/class-plan/${classPlanID}`);
    } else {
      localStorage.removeItem("classPlanID");
      const payload = {
        id: classDetails?.id,
        title: classDetails?.title,
        description: "string",
        createdOn: 0,
        modifiedOn: 0,
        teacher_id: classDetails?.teacher_id,
      };
      createNewClassPlan({ classPlanData: payload, classID: classID });
    }
  };

  const goToClassPlan = () => {
    if (slicePath.includes("class-plan")) {
      history.push(`/class/${classID}/edit-students`);
    } else {
      history.push(`/teacher/start-live-class`);
    }

    // const classPlanID = localStorage.getItem("classPlanID");
    // history.push(`/class/${classID}/class-plan/${classPlanID}`);
  };

  return (
    <Route
      {...rest}
      render={(matchProps) =>
        redirectRoute ? (
          <Redirect push to={redirectRoute} />
        ) : (
          <div className={"layout InternalLayout"}>
            <img
              src={logo}
              className={"p-3 absolute buddingAILogo cursor-pointer"}
              alt="budding-ai-logo"
              onClick={() => history.push("/")}
              draggable={false}
            />
            <button
              className="absolute px-4 py-2 cursor-pointer top-0 right-0 rounded m-4 z-50"
              onClick={() => keycloak.logout()}
            >
              <div className="flex justify-between items-center gap-3">
                <img
                  src={logOut}
                  className="h-4 w-4"
                  alt="Logout"
                  draggable={false}
                />
                <span className="text-black text-base">Logout</span>
              </div>
            </button>
            <span className="lg:block hidden fixed bottom-0 right-0 mr-5 mb-5"
             style={{ zIndex: 100 }}
             >
              {classCreatedURl === "class" && (
                <div>
                  {isClassPlanUpdate ? (
                    <span
                      className="ml-2 border-b border-b-black cursor-pointer"
                      onClick={() => goToClassPlan()}
                    >
                      {`${
                        slicePath.includes("class-plan")
                          ? "Edit Students"
                          : "Go To Class"
                      }`}
                    </span>
                  ) : (
                    <span
                      className="ml-2 border-b border-b-black cursor-pointer"
                      onClick={() => redirectToCreateClassPlan()}
                    >
                      Go To Class Plan
                    </span>
                  )}
                </div>
              )}

              {/* {classCreatedURl !== "class" && (
                <Link
                  to={`/teacher/${keycloak?.idTokenParsed?.sid}/edit-teacher-profile`}
                >
                  <span className="ml-2 border-b border-b-black">
                    Edit profile
                  </span>
                </Link>
              )} */}
            </span>

            <div className={"content "}>
              <Component {...matchProps} />
            </div>
            <span className=" lg:hidden flex justify-end mr-5 mb-5">
              {classCreatedURl === "class" && !isClassPlanPath && (
                <div>
                  {isClassPlanUpdate ? (
                    <span
                      className="ml-2 border-b border-b-black  cursor-pointer"
                      onClick={() => goToClassPlan()}
                    >
                      {`${
                        slicePath.includes("class-plan")
                          ? "Edit Students"
                          : "Go To Class"
                      }`}
                    </span>
                  ) : (
                    <span
                      className="ml-2 border-b border-b-black  cursor-pointer"
                      onClick={() => redirectToCreateClassPlan()}
                    >
                      Go To Class Plan
                    </span>
                  )}
                </div>
              )}
              {/* {classCreatedURl !== "class" && (
                <Link
                  to={`/teacher/${keycloak?.idTokenParsed?.sid}/edit-teacher-profile`}
                >
                  <span className="ml-2 border-b border-b-black">
                    Edit profile
                  </span>
                </Link>
              )} */}
            </span>
          </div>
        )
      }
    />
  );
};

export default InternalTeacher;

InternalTeacher.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};
